/**
 * Classe com os events actions pra funcionalidade de manage events.
 * @author: adalto.junior
 * Date: 12/10/13
 * Time: 11:18
 */

Greenmile.Event = Greenmile.Event || {};
Greenmile.Event.EventAction = {
  DatabaseIntegration: {
    assignParameter: (jsonParam) => {
      if (jsonParam) {
        jsonParam = JSON.parse(jsonParam);
        $('#action_db_username').val(jsonParam.username);
        $('#action_db_password').val(jsonParam.password);
        $('#action_db_url').val(jsonParam.url);
        $('#action_db_driverClass').val(jsonParam.driverClass);
        $('#action_db_statement').val(jsonParam.statement);
      }
    },
    retrieveParameter: () => (
      JSON.stringify({
        username: $('#action_db_username').val(),
        password: $('#action_db_password').val(),
        url: $('#action_db_url').val(),
        driverClass: $('#action_db_driverClass').val(),
        statement: $('#action_db_statement').val()
      })
    )
  },
  Email: {
    assignParameter: jsonParam => Greenmile.Actions.EMAIL.assignParameter(jsonParam),
    retrieveParameter: () => (Greenmile.Actions.EMAIL.retrieveParameter())
  },
  Sms: {
    assignParameter: jsonParam => Greenmile.Actions.SMS.assignParameter(jsonParam),
    retrieveParameter: () => (Greenmile.Actions.SMS.retrieveParameter())
  },
  DeliveryAlert: {
    assignParameter: jsonParam => Greenmile.Actions.DeliveryAlert.assignParameter(jsonParam),
    retrieveParameter: () => (Greenmile.Actions.DeliveryAlert.retrieveParameter())
  },
  HttpRequest: {
    assignParameter: jsonParam => Greenmile.Actions.HttpRequest.assignParameter(jsonParam),
    retrieveParameter: () => (Greenmile.Actions.HttpRequest.retrieveParameter())
  },
  ManagerNotification: {
    assignParameter: jsonParam => Greenmile.Actions.ManagerNotification.assignParameter(jsonParam),
    retrieveParameter: () => (Greenmile.Actions.ManagerNotification.retrieveParameter())
  },
  NoAttributes: {
    assignParameter: () => {},
    retrieveParameter: () => (
      JSON.stringify({
        noAttributes: true
      })
    )
  }
};
